import { isRegionIdInRegions } from '@/configuration/helpers/helpers'

export const getLocationRegionId = location => {
  return location?.address?.province?.region_id || location?.address?.country?.region_id || null
}

export const getSelectedRegionIds = methodRegions => {
  return methodRegions?.map(region => region.id).filter(Boolean) || []
}

export const validateSourceRegions = ({ sourceRegionIds, methodRegions, allRegions }) => {
  if (!sourceRegionIds?.length) return true

  for (const region of methodRegions || []) {
    const isSourceRegionValid = isRegionIdInRegions(region.id, sourceRegionIds, allRegions)
    if (!isSourceRegionValid) {
      return false
    }
  }
  return true
}

export const validateDestinationRegions = ({ destinationRegionIds, location, allRegions }) => {
  if (!destinationRegionIds?.length) return true

  const locationRegionId = getLocationRegionId(location)

  if (!locationRegionId) {
    return false
  }

  return isRegionIdInRegions(locationRegionId, destinationRegionIds, allRegions)
}

export const getMethodsUsedInCriterion = (methods, criterionMethodIds) => {
  return methods?.filter(method => criterionMethodIds?.includes(method?.id))
}
